import controller from './preview.controller';
import template from './preview.html';
import './preview.scss';

export default {
	path:           '/preview/:kid',
	template,
	controller,
	controllerAs:   '$ctrl',
	title:          'common.preview',
	reloadOnSearch: false,
};
